import { render, staticRenderFns } from "./PaymentAdmin.vue?vue&type=template&id=86936b28&"
import script from "./PaymentAdmin.vue?vue&type=script&lang=js&"
export * from "./PaymentAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports